import ChallengeTypeTrivia from './ChallangeTypeTrivia';

export default ChallengeTypeTrivia;
